import { bindActionCreators } from 'redux';
import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import LoadEstimateLoader from './LoadEstimateLoader';
import loadDesign from '../actions/loadEstimate';
import clearDesignsByMode from '../actions/clearDesignsByMode';
import cartConvertedSuccessfully from '../actions/cartConvertedSuccessfully';

const mapStateToProps = (state) => {
  const selectedEstimateId = get('estimateBuilder.uiState.selectedEstimate')(state);

  return ({
    selectedEstimate: get(`estimateBuilder.entities.estimates.byId[${selectedEstimateId}]`)(state),
  });
};
const mapDispatchToProps = dispatch => bindActionCreators({
  loadDesign,
  cartConvertedSuccessfully,
  clearDesignsByMode,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoadEstimateLoader);
